import React, {useState} from 'react';

import PropTypes from 'prop-types';

import {CommandPaletteContext} from '../components/CommandPalette/CommandPaletteContext';
import {store} from '../state/store';
import {getGlobalHotKeys} from '../utils/commandPalette';

const CommandPaletteView = ({children}) => {
  const globalHotKeys = getGlobalHotKeys(store.dispatch);
  const [hotkeys, setHotkeys] = useState(globalHotKeys);
  const addPageHotkeys = (pageHotkeys = []) => {
    const newHotkeys = [...pageHotkeys, ...globalHotKeys].sort((a, b) => {
      if (a.section === b.section) {
        return a.order - b.order;
      } else {
        return 0;
      }
    });
    setHotkeys(newHotkeys);
  };
  const resetPageHotkeys = () => setHotkeys(globalHotKeys);

  return (
    <CommandPaletteContext.Provider
      value={{hotkeys, addPageHotkeys, resetPageHotkeys}}
    >
      {children}
    </CommandPaletteContext.Provider>
  );
};

CommandPaletteView.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CommandPaletteView;
